import { render } from "./HomepageDropdown.vue?vue&type=template&id=54662b82"
import script from "./HomepageDropdown.vue?vue&type=script&lang=js"
export * from "./HomepageDropdown.vue?vue&type=script&lang=js"

import "./HomepageDropdown.vue?vue&type=style&index=0&id=54662b82&lang=css"
script.render = render

export default script